<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Beneficios (Regalos)
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="nuevo" v-html="'Nuevo'" />
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12">
                        <ModalBeneficio :objFormBene="objFormBene" :listGeneral="listGeneral" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Tipo Beneficio *" color="textbox" v-model="objSearchBene.idTipoBeneficio"
                            :items="listGeneral.listTipoBeneficio" item-value="idTipoBeneficio" item-text="tipoBeneficio"
                            @change="listGeneral.detalle = [];onListarBeneficios($event,'L_COMBO','detalle',true)"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Proveedor *" color="textbox" v-model="objSearchBene.idProveedor"
                            :items="listGeneral.listProveedores" item-value="idProveedor" item-text="proveedor"
                            @change="listGeneral.detalle = [];onListarBeneficios($event,'L_COMBO','detalle',true)"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objSearchBene.idEstado"
                            :items="listGeneral.listEstados" item-text="nombre_estado" item-value="id_estado"
                            @change="listGeneral.detalle = [];onListarBeneficios($event,'L_COMBO','detalle',true)"
                            outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearchBene.search" clearable
                            prepend-inner-icon="search" dense/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objSearchBene.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">
                            
                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editar(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:item.tipobeneficio="{ item }">
                                {{ item.tipoBeneficio }}
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="objSearchBene.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "BeneficioView",
        components: {
            ModalBeneficio: () => import('@/components/beneficio/ModalBeneficioComponent.vue')
        },
        data() {
            return {
                objSearchBene: {},
                objFormBene: {},
                listGeneral: [],
                listParametros: {}
            }
        },
        created() {
            axios.post(`${BASE_URI}administrador/beneficio/cargaGeneral`,{})
                .then((r) =>{
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                    this.listGeneral = r.data.data.listas;
                    this.listParametros = r.data.data.listParametros;
                    this.listGeneral.listTipoBeneficio = _.filter(this.listGeneral.listTipoBeneficio, (v) => {
                        return v.visualiza == 'true'
                    });
                    this.objSearchBene = {
                        idTipoBeneficio: this.listGeneral.listTipoBeneficio[0].idTipoBeneficio,
                        idEstado: _.toString(this.listParametros.idEstadoDefault)
                    };
        
                    this.objFormBene = _.clone(this.objSearchBene);
        
                    this.cargaGeneral();
                })
                .catch((e) =>{
                    mensajesAlerta(e, 'E');
                });
        },
        methods: {
            cargaGeneral() {
                this.onListarBeneficios('L', 'L_COMBO', 'detalle')
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            },
            apiSend(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto);
            },
            onListarBeneficios(event, opcion, lista, isEvent = false, obj = null) {
                if (!_.isUndefined(event)) {
                    var objeto = _.isNull(obj) ? _.merge({}, this.objSearchBene, { opcion: opcion }) : _.merge({}, obj, { opcion: opcion });

                    var p = this.apiSend('administrador/beneficio/listar', objeto)
                        .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (r.data.existeError) throw mensajeEstandar.errorPeticion;
                            if (_.size(r.data.data) > 0) {
                                switch (lista) {
                                    case 'objFormBene':
                                        this.$set(this, lista, r.data.data[0]);
                                        break;
                                    default:
                                        this.$set(this.listGeneral, lista, _.map(r.data.data, (v) => {
                                                                                                        v.estado = (_.find(this.listGeneral.listEstados, (o) => {
                                                                                                                        return parseInt(o.id_estado) == parseInt(v.idEstado)})).nombre_estado;
                                                                                                        return v;
                                                                                                    })
                                                );
                                        break;
                                }
                            } else
                                mensajesAlerta(r.data.mensaje, 'I');
                            return r;
                        });

                    if (isEvent)
                        p.catch((e) => {
                            mensajesAlerta(e, 'E');
                        });

                    return p;
                }
            },
            nuevo() {
                this.$children[0].$children[6].cargaGeneral(true);
            },
            editar(objeto) {
                this.onListarBeneficios('L', 'LISTAR_BENEFICIOS', 'objFormBene', false, objeto)
                    .then((r) => {
                        if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r,['data','data'],[])) > 0) 
                            this.$children[0].$children[6].cargaGeneral(true);                        
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            },
            insertarActualizar() {
                this.apiSend('administrador/beneficio/insertOrUpdate', this.objFormBene)
                    .then((r) => {
                        if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if (r.data.existeError) throw mensajeEstandar.errorPeticion;
                        if (_.size(r.data.data) > 0) {
                            this.$children[0].$children[6].cargaGeneral(false);
                            mensajeAlertaTiempo(r.data.mensaje, 'S');
                            return this.onListarBeneficios('L', 'L_COMBO', 'detalle');
                        }
                    }).catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            }
        }
    }
</script>